// Module
var code = "<span class=\"github-button-widget\">\n  <a\n    class=\"github-button\"\n    :href=\"repositoryLink\"\n    data-icon=\"octicon-star\"\n    data-show-count=\"true\"\n    :aria-label=\"ariaLabel\">\n    Star\n  </a>\n</span>\n";
// Exports
export default code;